import PropTypes from 'prop-types';
import React from 'react';

import { childrenShape } from '@bibliocommons/bc-prop-types';

import Breadcrumbs from 'app/components/shared/Breadcrumbs';
import Heading from 'app/components/shared/Heading';
import breadcrumbLinksShape from 'app/shapes/breadcrumbLinksShape';

import './BrowseCategoryPage.scss';

const BrowseCategoryPage = ({ breadcrumbLinks, children, pageTitle }) => {
  return (
    <article className="cp-browse-category-page">
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <header>
              <Breadcrumbs className="breadcrumbs" hasUiRouterLinks links={breadcrumbLinks} />
              <Heading className="heading-primary" id="BrowseCategory" size="large" tagName="h1" variant>
                {pageTitle}
              </Heading>
            </header>
          </div>
        </div>
      </div>
      {children}
    </article>
  );
};

BrowseCategoryPage.propTypes = {
  breadcrumbLinks: breadcrumbLinksShape.isRequired,
  children: childrenShape.isRequired,
  pageTitle: PropTypes.string.isRequired
};

export default BrowseCategoryPage;
